import React from 'react';

import cn from 'classnames';

import css from './FlexBox.css';

export interface FlexBoxProps {
    className?: string;
    tagName?: keyof HTMLElementTagNameMap;
    direction?: React.CSSProperties['flexDirection'];
    gap?: number;
    grow?: React.CSSProperties['flexGrow'];
    shrink?: React.CSSProperties['flexShrink'];
    wrap?: React.CSSProperties['flexWrap'];
    align?: React.CSSProperties['alignItems'];
    justify?: React.CSSProperties['justifyContent'];
}

const FlexBox: React.FC<React.PropsWithChildren<FlexBoxProps>> = ({
    className,
    tagName = 'div',
    children,
    direction,
    gap = 10,
    wrap,
    align,
    justify,
    grow,
    shrink,
}) => {
    return React.createElement(
        tagName,
        {
            className: cn(css.root, className),
            style: {
                flexDirection: direction,
                gap,
                flexWrap: wrap,
                justifyContent: justify,
                alignItems: align,
                flexGrow: grow,
                flexShrink: shrink,
            },
        },
        children,
    );
};

export default FlexBox;
